// src/api/user.ts
import { http } from './http';

export type SessionResponse = {
  isAuthenticated: boolean;
  user?: { id: string; username: string };
};

export type AccessPayload = {
  login: string;
  password: string;
};

export function access(data: AccessPayload) {
  return http.post('User/access', data);
}

// ✅ endpoints iguais ao seu projeto antigo (services/userService.tsx)
export function session() {
  return http.get<SessionResponse>('User/session');
}

export function logout() {
  return http.post('User/logout');
}

export function getSubscriberAuthUrl() {
  return http.get<{ url: string }>('Subscriber/url-auth');
}

// ✅ ESTE é o que seu AuthCallback precisa chamar
export function subscriberAuth(code: string) {
  // no seu projeto antigo era: instance.post(`Subscriber/subscriber-auth`, code)
  // ou seja: body é o "code" puro (string), não objeto { code }
  return http.post('Subscriber/subscriber-auth', code, {
    headers: { 'Content-Type': 'application/json' },
  });
}

// (opcional) se no seu projeto atual você usa oauthCallback em algum lugar
export const oauthCallback = subscriberAuth;